export default __webpack_public_path__ + "static/media/vista-volcan-lago-isla.5ab560a1.jpeg";